

// Budget Wig Slider

 $(document).ready(function () {
  $(".budgetWigsCarousel").owlCarousel({
    loop: true,
    margin: 30,
    autoplay: false,
    autoplayTimeout: 5000,
    autoplayHoverPause: true,
    dots: false,
    nav: true,
    navText: [
      `<img src="https://cdn.shopify.com/s/files/1/0707/3703/5498/files/arrow-left1.svg?v=1771494090" class="owl-prev-btn" />`,
      `<img src="https://cdn.shopify.com/s/files/1/0707/3703/5498/files/arrow-right11.svg?v=1771494039" class="owl-next-btn" />`
    ],
    responsive: {
      0: {
        items: 1
      },
      480: {
        items: 2
      },
      768: {
        items: 3
      },
      1199: {
        items: 3
      },
       1200: {
        items: 4
      }
    }
  });
});



// Banner Slider

$(document).ready(function () {
  $(".bannerSlider").owlCarousel({
    loop: true,
    margin: 30,
    autoplay: false,
    autoplayTimeout: 5000,
    autoplayHoverPause: true,
    dots: false,
    nav: true,
    navText: [
      `<img src="https://cdn.shopify.com/s/files/1/0707/3703/5498/files/arrow-left1.svg?v=1771494090" class="owl-prev-btn" />`,
      `<img src="https://cdn.shopify.com/s/files/1/0707/3703/5498/files/arrow-right11.svg?v=1771494039" class="owl-next-btn" />`
    ],
    items: 1
  });
});